// Captures a ?ref=XXXXXX referral code from the URL on app load and stashes
// it in localStorage so it survives navigation. The Settings page reads it
// to pre-fill the redeem input and clears it after a successful redeem.
const KEY = "fff_pending_ref";

export const captureRefFromUrl = () => {
  try {
    const params = new URLSearchParams(window.location.search);
    const code = (params.get("ref") || "").trim().toUpperCase();
    if (code && /^[A-Z0-9]{4,10}$/.test(code)) {
      localStorage.setItem(KEY, code);
      return code;
    }
  } catch { /* SSR / older browsers */ }
  return null;
};

export const getPendingRef = () => {
  try { return (localStorage.getItem(KEY) || "").trim().toUpperCase() || null; }
  catch { return null; }
};

export const clearPendingRef = () => {
  try { localStorage.removeItem(KEY); } catch { /* ignore */ }
};
